import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    PillCellComponent,
    PillHeaderCellComponent,
    PillHeaderRowComponent,
    PillRowComponent,
    PillTableComponent
} from '@tran-monorepo/frontend/components';

@Component({
    selector: 'tran-customer-home-dates-and-deadlines-skeleton',
    imports: [PillTableComponent, PillCellComponent, PillRowComponent, PillHeaderRowComponent, PillHeaderCellComponent],
    template: `<tran-pill-table rowClasses="font-bold" aria-hidden="true">
        <tran-pill-header-row>
            @for (headerIdx of [0, 1, 2]; track $index) {
                <tran-pill-header-cell>
                    <span class="si-skeleton placeholder-lg w-75"></span>
                </tran-pill-header-cell>
            }
        </tran-pill-header-row>

        @for (meetingIdx of [0, 1, 2]; track meetingIdx) {
            <div [class]="meetingIdx > 0 ? 'mt-8' : ''">
                @if (meetingIdx === 0) {
                    <tran-pill-header-row>
                        <span class="si-skeleton w-50"></span>
                    </tran-pill-header-row>
                }

                <div flex="flex flex-col gap-1">
                    @for (deadlineIdx of [0, 1]; track deadlineIdx) {
                        <tran-pill-row [class]="meetingIdx === 0 && deadlineIdx === 0 ? 'mb-10' : 'mb-1'">
                            <tran-pill-cell
                                [bgColor]="
                                    meetingIdx === 0 && deadlineIdx === 0 ? 'bg-data-turquoise-1' : 'bg-deep-blue-725'
                                "
                            >
                                <span class="si-skeleton w-100"></span>
                            </tran-pill-cell>
                            <tran-pill-cell
                                [bgColor]="
                                    meetingIdx === 0 && deadlineIdx === 0 ? 'bg-data-turquoise-3' : 'bg-deep-blue-750'
                                "
                            >
                                <span class="si-skeleton w-100"></span>
                            </tran-pill-cell>
                            <tran-pill-cell
                                [bgColor]="
                                    meetingIdx === 0 && deadlineIdx === 0 ? 'bg-data-turquoise-4' : 'bg-deep-blue-800'
                                "
                            >
                                <span class="si-skeleton w-100"></span>
                            </tran-pill-cell>
                        </tran-pill-row>
                    }
                </div>
            </div>
        }
    </tran-pill-table>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatesAndDeadlinesSkeletonComponent {}
